import { render, staticRenderFns } from "./ShowTermsAndPrivacy.vue?vue&type=template&id=73a2d19c&scoped=true"
import script from "./ShowTermsAndPrivacy.vue?vue&type=script&lang=ts"
export * from "./ShowTermsAndPrivacy.vue?vue&type=script&lang=ts"
import style0 from "./ShowTermsAndPrivacy.vue?vue&type=style&index=0&id=73a2d19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a2d19c",
  null
  
)

export default component.exports